import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel (only once)
    if (window.fbq) return; // Already initialized
    // Create fbq function
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    // Create and append script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize with Pixel ID after script loads
    script.onload = () => {
      window.fbq('init', '2030573284537137');
      window.fbq('track', 'PageView');
    };
    // Global click listener for AddToCart tracking (event delegation)
    const handleGlobalClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const addToCartButton = target.closest('[data-mp="addtocart-nbb"]');
      if (addToCartButton) {
        console.log('[DEBUG] NBB AddToCart click captured');
        // Prevent immediate navigation
        e.preventDefault();
        // Track AddToCart event
        trackAddToCart();
        // Get destination URL
        const href = addToCartButton.getAttribute('data-href');
        // Wait 150ms then navigate
        if (href) {
          setTimeout(() => {
            window.location.href = href;
          }, 150);
        }
      }
    };
    // Add global click listener
    document.addEventListener('click', handleGlobalClick);
    // Cleanup
    return () => {
      document.removeEventListener('click', handleGlobalClick);
    };
  }, []);
  return <noscript data-id="element-55">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2030573284537137&ev=PageView&noscript=1" alt="" data-id="element-56" />
    </noscript>;
}
// Helper function to track AddToCart event
export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Nail Biz Blueprint',
      content_ids: ['53597198778701'],
      content_type: 'product',
      value: 37.0,
      currency: 'USD'
    });
  }
}